import React from 'react'
import numbro from 'numbro'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import { convertMetersToUnit } from 'supporticon/utils/units'

import Grid from 'constructicon/grid'
import GridColumn from 'constructicon/grid-column'
import Metric from 'constructicon/metric'
import Progress from 'constructicon/progress-bar'

const ProgressBar = ({
  barBackground = 'shade',
  barForeground = 'primary',
  barRadius = 'small',
  customSupporterPage,
  fundraisingPage,
  raisedLabel,
  styles,
  target,
  targetLabel,
  type
}) => {
  const { fitness } = customSupporterPage

  const totals = type === 'distance'
    ? {
      amount: numbro(fundraisingPage.fitnessDistanceTotal).format('0,0'),
      target: numbro(fundraisingPage.fitnessGoal).format('0,0'),
      progress: convertMetersToUnit(fundraisingPage.fitnessDistanceTotal, fitness.goalUom) / fundraisingPage.fitnessGoal * 100
    } : {
      amount: numbro(fundraisingPage.raised).format('$0,0'),
      target: numbro(fundraisingPage.target).format('$0,0'),
      progress: fundraisingPage.raised / fundraisingPage.target * 100
    }

  return (
    <Grid spacing={0.25}>
      {raisedLabel && (
        <GridColumn xs={6}>
          <Metric
            align='left'
            amount={totals.amount}
            label={raisedLabel}
            styles={styles.metric}
          />
        </GridColumn>
      )}
      {targetLabel && (
        <GridColumn xs={6}>
          <Metric
            align='right'
            amount={totals.target}
            label={targetLabel}
            styles={styles.metric}
          />
        </GridColumn>
      )}
      <GridColumn>
        <Progress
          alt='<%= progress %>% there'
          background={barBackground}
          progress={totals.progress}
          fill={barForeground}
          radius={barRadius}
          styles={styles.progress}
        />
      </GridColumn>
    </Grid>
  )
}

export default withStyles(styles)(ProgressBar)
